export const Errors = {
    NO_CONFIG: {
        code: 600,
        message: "No Configuration Found. ",
        custom: true
    },
    NO_CONVO_FOUND: {
        code: 601,
        message: "No Conversation found to process. ",
        custom: true
    },
    NO_SITE_CODE: {
        code: 602,
        message: 'No Site Code. ',
        custom: true
    },
    NO_CONFIG_CODE: {
        code: 603,
        message: 'No Config Code. ',
        custom: true
    },
    NO_JQUERY: {
        code: 604,
        message: 'Jquery not loaded. ',
        custom: true
    },
    NO_METER_LEVEL_SET: {
        code: 605,
        message: 'No meter level set. ',
        custom: true
    },
    NO_CAMPAIGN: {
        code: 606,
        message: 'No campaign data. ',
        custom: true
    },
    NO_AUTH0_LOCK: {
        code: 607,
        message: 'No auth0Lock object in the authSettings! ',
        custom: true
    },
    UNKNOWN_REG_TYPE: {
        code: 608,
        message: 'Unknown registration type. ',
        custom: true
    },
    UNKNOWN_USER_STATE: {
        code: 609,
        message: 'Unknown user state. ',
        custom: true
    },
    NO_USER_DATA: {
        code: 610,
        message: 'No user data result. ',
        custom: true
    },
    NO_JANRAIN_DATA: {
        code: 611,
        message: 'No user data UUID. ',
        custom: true
    },
    CONFIG_HAS_NOT_PUBLISHED: {
        code: 612,
        message: 'Configuration has not published. ',
        custom: true
    },
    S3DATA_IS_INVALID: {
        code: 613,
        message: 's3Data is not an object. ',
        custom: true
    },
    HIDE_CONTENT: {
        code: 614,
        message: 'Cannot hide content! ',
        custom: true
    },
    LOAD_ERRORS: {
        cookie: {
            ErrorMessage: 'Data can not be written to the cookie storage.'
        },
        configCode: {
            ErrorMessage: 'Incorrect or not specified configCode.'
        },
        siteCode: {
            ErrorMessage: 'Incorrect or not specified siteCode.'
        },
        auth0Lock: {
            ErrorMessage: 'Auth0Lock is not defined.'
        },
        configuration: {
            ErrorMessage: 'No configuration found to process.'
        },
        networkError: {
            ErrorMessage: 'No network.'
        }
    },
    MALFORMED_AUTH0_OPTIONS: {
        code: 615,
        message: "Malformed Auth0 client options",
        custom: true
    }
};
